import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import LinksPage from './pages/LinksPage';
import FaucetPage from './pages/FaucetPage';
import WalletSettings from './pages/WalletSettings';
import WithdrawalsPage from './pages/WithdrawalsPage';
import RedirectPage from './pages/RedirectPage';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#07080D]">
          <Routes>
            {/* Redirect page without navbar */}
            <Route path="/r/:shortCode" element={<RedirectPage />} />

            {/* Main routes with navbar */}
            <Route
              path="*"
              element={
                <>
                  <Navbar />
                  <Routes>
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/auth" element={<AuthPage />} />
                    <Route
                      path="/dashboard"
                      element={
                        <ProtectedRoute>
                          <DashboardPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/links"
                      element={
                        <ProtectedRoute>
                          <LinksPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/faucet"
                      element={
                        <ProtectedRoute>
                          <FaucetPage />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/wallet"
                      element={
                        <ProtectedRoute>
                          <WalletSettings />
                        </ProtectedRoute>
                      }
                    />
                    <Route
                      path="/wallet/history"
                      element={
                        <ProtectedRoute>
                          <WithdrawalsPage />
                        </ProtectedRoute>
                      }
                    />
                  </Routes>
                </>
              }
            />
          </Routes>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: '#131622',
                border: '1px solid rgba(255,255,255,0.1)',
                color: '#F8FAFC',
              },
            }}
          />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
